const EOU_SUBSCRIBE_API = 'https://www.coinbase.com/graphql/query?&operationName=emailOnlyUserApiMutation';
const EOU_PREVIEW_API = 'https://graphql-dev.cbhq.net/query?&operationName=emailOnlyUserApiMutation';
export { EOU_PREVIEW_API, EOU_SUBSCRIBE_API };
//# sourceMappingURL=constants.js.map
